import { Dispatch, SetStateAction } from 'react'
import * as React from 'react'
import Header from '@components/organisms/Header/Header'
import Footer from '@components/organisms/FooterNew'
import { LayoutContainer, PageContainer } from './styled.components'
import SearchSection from '@components/molecules/SearchSection'
const MobileNavigation = dynamic(() => import('../MobileNavigation'), {
  ssr: false,
})
const GroupedButtons = dynamic(
  () => import('@components/molecules/GroupedButtons'),
  {
    ssr: false,
    loading: () => (
      <div className="flex justify-between w-full min-w-[78rem] items-center mt-2 sm:ml-0 py-2 px-[12px] ml-[7.6px]">
        {GroupedButtonsLoading}
      </div>
    ),
  }
)

import useWindowScroll from '@hooks/useScroll'
import dynamic from 'next/dynamic'
import GroupedButtonsLoading from '@components/organisms/Skeletons/GroupedButtonsLoading'
import useWindowDimensions from '@hooks/useWindowDimensions'

type LayoutProps = {
  children: React.JSX.Element | React.JSX.Element[]
  fullWidth?: boolean
  displayHeaderAsHelpCentre?: boolean
  onLogoClick?: () => void
  category?: string
  setCategory?: Dispatch<SetStateAction<string>>
  showCategories?: boolean
  hideHeader?: boolean
  hideSearchOnMobile?: boolean
  customHeader?: Element | boolean
  hideSearchOnMobileSize?: string
  clearPadding?: boolean
  hideLogoOnMobile?: boolean
  childWrapperClassName?: string
}
const Layout: React.FC<LayoutProps> = ({
  children,
  fullWidth = false,
  displayHeaderAsHelpCentre = false,
  onLogoClick,
  showCategories = false,
  category = undefined,
  setCategory = undefined,
  hideHeader = false,
  hideSearchOnMobile = false,
  customHeader = false,
  hideSearchOnMobileSize = 'sm',
  clearPadding = false,
  hideLogoOnMobile = false,
  childWrapperClassName = '',
}) => {
  const { scrollPosition } = useWindowScroll()
  const { width } = useWindowDimensions()

  // Horizontal overflow is now clipped globally via CSS on the Next.js app
  // wrapper (#__next) using `overflow-x: clip` — not on <html>/<body> and not
  // the old inline `overflow-x: hidden`. A mid-tree `overflow-x: clip` with
  // visible overflow-y doesn't create a scroll container, so it doesn't break
  // position: sticky.

  const showCategorySlider =
    showCategories && category !== undefined && setCategory !== undefined

  return (
    <LayoutContainer>
      <PageContainer clearPadding={clearPadding} fullWidth={fullWidth}>
        <Header
          displayHelpCentreTitle={displayHeaderAsHelpCentre}
          onLogoClick={onLogoClick}
          hideHeader={hideHeader}
          hideLogoOnMobile={hideLogoOnMobile}
        />
        {customHeader && customHeader}
        <div className="flex flex-col sticky top-0 z-[2] bg-white">
          {!hideSearchOnMobile && (
            <div
              className={`${hideSearchOnMobileSize}:hidden bg-white flex w-full px-3 pt-2 h-16 items-center z-20`}
            >
              <SearchSection />
            </div>
          )}
          {showCategorySlider && (
            <div
              className={`sm:hidden flex w-full xs:w-[calc(100%+0.8rem)] xs:-ml-[0.4rem] bg-white z-10 ${
                scrollPosition < 89 && 'shadow-sm'
              }`}
              style={
                scrollPosition > 89
                  ? {
                      boxShadow: '0 3px 10px rgba(0 0 0/0.1)',
                    }
                  : undefined
              }
            >
              <GroupedButtons category={category} setCategory={setCategory} />
            </div>
          )}
        </div>
        <div className={`flex flex-col sm:mx-0 mx-4 ${childWrapperClassName}`}>
          {children}
        </div>
        <Footer />
      </PageContainer>
      {(width || 1025) < 1024 ? <MobileNavigation /> : <></>}
    </LayoutContainer>
  )
}

export default Layout
